<template>
  <div id="app" v-loading="loading" element-loading-text="加载中...">
    <keep-alive>
      <!-- 这里是会被缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <div class="unSetInfo-dialog" v-if="unSetInfoDialog">
      <div class="content">
        <img src="./assets/img/unSetInfo.png" alt="" />
        <p>
          欢迎使用全税种税务管理系统，请先前往【企业基础信息】功能将企业信息维护完整
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { default as api } from "@/api/login/login";

export default {
  name: "App",
  data() {
    return {
      path: null,
      currentDeptId: null, //当前公司
      loading: false,
      unSetInfoDialog: false,
    };
  },
  computed: {
    ifSetInfo() {
      const { currentDeptId, path } = this;
      return { currentDeptId, path };
    },
  },
  created() {
    this.setCookies();
  },
  methods: {
    // 获取查询字符串
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return null;
    },
    async setCookies() {
      const sessionValue = this.getQueryVariable("dxhy_sso_sessionid");
      if (sessionValue) {
        await api
          .setCookieGet({ dxhy_sso_sessionid: sessionValue })
          .then((r) => {
            if (r.code === 200) {
              this.getUserInfo();
            } else {
              this.$message.error(r.msg);
            }
          })
          .catch((e) => {
            e.redirectUrl && window.location.replace(e.redirectUrl);
          });
      } else {
        await api
          .setCookiePost()
          .then((r) => {
            if (r.code === 200) {
              this.getUserInfo();
            } else {
              this.$message.error(r.msg);
            }
          })
          .catch((e) => {
            e.redirectUrl && window.location.replace(e.redirectUrl);
          });
      }
    },
    getUserInfo() {
      api.getUserInfo().then((r) => {
        if (r.code === 200) {
          this.currentDeptId = r.data.currentDeptId;
        } else {
          this.$message.error(r.msg);
        }
      });
    },
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
    ifSetInfo(val) {
      if (val.currentDeptId && val.path) {
        // 未维护企业信息菜单，弹窗提示
        if (
          [
            "/declare",
            "/provision",
            "/ledgerTask",
            "/declarationform",
          ].includes(this.path)
        ) {
          this.loading = true;
          api.isempty(val.currentDeptId).then((r) => {
            if (r.code === 200) {
              this.loading = false;
              this.unSetInfoDialog = !r.flag; //flag true已维护企业信息  false未维护企业信息
            } else {
              this.$message.error(r.message);
              this.unSetInfoDialog = false;
            }
          });
        } else {
          this.loading = false;
          this.unSetInfoDialog = false;
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "./common/iconfont/iconfont.css";
@import "./common/base.scss";
#app {
  padding: 20px;
  height: 100%;
  background: #fff;
  position: relative;
}

// #app > div {
//   height: 100%;
// }

.unSetInfo-dialog {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 9999;
  .content {
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -140px 0 0 -370px;
    img {
      width: 300px;
      display: block;
      margin: 0 auto 20px;
    }
    p {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue